import { render, staticRenderFns } from "./TrueFalseQuestion.vue?vue&type=template&id=5698e4c6&scoped=true&"
import script from "./TrueFalseQuestion.vue?vue&type=script&lang=js&"
export * from "./TrueFalseQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TrueFalseQuestion.vue?vue&type=style&index=0&id=5698e4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5698e4c6",
  null
  
)

export default component.exports